var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"events-overview overflow-hidden relative bg-black text-white pt-16 pb-8 lg:pt-40 lg:pb-16"},[_c('p',{ref:"text",staticClass:"events-overview__text font-gt-america-regular absolute top-0 mt-6 lg:mt-16 whitespace-no-wrap"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"relative"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }